<template>
  <div>
    <v-row v-for="(item, key) in items" :key="key" :align="align">
      <v-col v-if="item.icon" cols="auto">
        <v-img
          v-if="imgType === 'image'"
          contain
          :width="iconSizeFinal"
          :height="iconSizeFinal"
          :src="$asset(`img/icons/${item.icon}.svg`)"
          eager
        />
        <v-icon v-else :size="iconSizeFinal" :class="`${item.iconColor}--text`">
          {{ item.icon }}
        </v-icon>
      </v-col>
      <v-col><span v-html="item.text" /></v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'InfoList',
  props: {
    items: {
      type: Array,
      required: true
    },
    align: {
      type: String,
      default: 'center'
    },
    imgType: {
      type: String,
      default: 'image'
    },
    iconSize: {
      type: [String, Number],
      default: '48'
    },
    iconSizeMobile: {
      type: [String, Number],
      default: '40'
    }
  },
  computed: {
    iconSizeFinal() {
      return this.$vuetify.breakpoint.smAndDown ? this.iconSizeMobile : this.iconSize;
    }
  }
};
</script>
